import { FC, useState } from 'react';

import cx from 'classnames';
import ReactDOM from 'react-dom';

import NavigationLinks from 'components/Layouts/Admin/Dashboard/Navigation/Links';
import styles from 'components/shared/ActionButtons/index.module.css';
import Divider from 'components/shared/Divider';
import BurgerLines from 'components/shared/Icon/icons/BurgerLines';
import Close from 'components/shared/Icon/icons/Close';
import UserMenuLinks from 'components/shared/Layout/shared/UserMenu/Links';

import Button from '../Button';
import s from './index.module.css';
import { IBurgerProps } from './types';

const Menu: FC<IBurgerProps> = ({ active, onClose }) => {
  if (!active) return null;

  return ReactDOM.createPortal(
    <div className={s.menu} onClick={onClose}>
      <button type="button" className={s.close} onClick={onClose}>
        <Close stroke="#fff" width="23px" height="23px" />
      </button>

      <div className={s.links}>
        <NavigationLinks linkClassName={s.linkItem} />
        <Divider className={s.divider} />
        {/*@ts-ignore*/}
        <UserMenuLinks />
      </div>
    </div>,
    document.body,
  );
};

const Burger = () => {
  const [active, setActive] = useState<boolean>(false);
  const handleClose = () => setActive(false);

  return (
    <>
      <Button
        size="extraSmall"
        type="grey"
        shape="circle"
        icon={BurgerLines}
        className={cx(styles.icon, s.burger)}
        onClick={() => setActive(!active)}
      >
        {null}
      </Button>

      <Menu active={active} onClose={handleClose} />
    </>
  );
};

export default Burger;
